import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { authorId: String }
  static targets = ["container", "bubble", "author"]

  connect() {
    const currentUserId = document.querySelector('meta[name="current-user-id"]')?.content
    const isMe = this.authorIdValue === currentUserId

    // Apply alignment and styling based on whether I am the author
    if (isMe) {
      // Outgoing (Me) -> Right side, blue bubble
      this.element.classList.remove('justify-start')
      this.element.classList.add('justify-end')
      
      this.containerTarget.classList.remove('items-start')
      this.containerTarget.classList.add('items-end')
      
      this.bubbleTarget.classList.remove('bg-gray-100', 'text-gray-800', 'rounded-tl-none')
      this.bubbleTarget.classList.add('bg-blue-600', 'text-white', 'rounded-tr-none', 'shadow-blue-500/20')
      
      if (this.hasAuthorTarget) {
        this.authorTarget.textContent = 'You'
      }
    } else {
      // Incoming (Other) -> Left side, gray bubble
      this.element.classList.remove('justify-end')
      this.element.classList.add('justify-start')
      
      this.containerTarget.classList.remove('items-end')
      this.containerTarget.classList.add('items-start')
      
      this.bubbleTarget.classList.remove('bg-blue-600', 'text-white', 'rounded-tr-none', 'shadow-blue-500/20')
      this.bubbleTarget.classList.add('bg-gray-100', 'text-gray-800', 'rounded-tl-none')
    }
    
    // Auto-scroll logic
    const messagesContainer = document.getElementById('messages-container')
    if (messagesContainer) {
      // Small timeout to ensure DOM has rendered
      setTimeout(() => {
        messagesContainer.scrollTop = messagesContainer.scrollHeight
      }, 50)
    }
  }
}
